import { Routes } from '@angular/router';

import { AuthGuard } from '@auth0/auth0-angular';

import { ErrorComponent } from '@/core/components/error/error.component';
import { ResetPasswordComponent } from '@/core/components/reset-password/reset-password.component';
import { roleGuard } from '@/core/guards/role.guard';
import { AuthComponent } from '@/core/components/auth/auth.component';
import { mainRoutes } from '@/main/main-routes';
import { profileGuard } from '@/core/guards/profile.guard';
import { entryGuard } from '@/core/guards/entryGuard';
import { resetGuard } from './core/guards/resetGuard';
import { sessionGuard } from './core/guards/session.guard';
import { AuthRedirectComponent } from './core/components/auth-redirect/auth-redirect.component';

export const routes: Routes = [
  {
    path: 'callback',
    loadComponent: () =>
      import('./core/components/callback/callback.component').then(
        mod => mod.CallbackComponent
      )
  },
  {
    path: 'auth-error',
    loadComponent: () =>
      import('./core/components/auth-error/auth-error.component').then(
        mod => mod.AuthErrorComponent
      )
  },
  { path: 'error/:code', component: ErrorComponent, title: $localize`Error` },
  { path: '', component: AuthComponent, canActivate: [entryGuard, sessionGuard] },
  ...mainRoutes,
  {
    path: 'signup-success',
    loadComponent: () =>
      import('./core/components/signup-success/signup-success.component').then(
        m => m.SignupSuccessComponent
      )
  },
  {
    path: 'change-password',
    loadComponent: () =>
      import('./core/components/auth/auth.component').then(
        m => m.AuthComponent
      ),
    data: { mode: 'change-password' }
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    title: $localize`Reset password`,
    canActivate: [resetGuard]
  },
  {
    path: 'reset-password-success',
    loadComponent: () =>
      import(
        './core/components/reset-password-success/reset-password-success.component'
      ).then(m => m.ResetPasswordSuccessComponent)
  },
  {
    path: 'settings',
    loadComponent: () =>
      import('./core/components/settings/settings.component').then(
        m => m.SettingsComponent
      ),
    canActivate: [AuthGuard]
  },
  {
    path: 'security',
    loadComponent: () =>
      import('./core/components/security/security.component').then(
        m => m.SecurityComponent
      ),
    canActivate: [AuthGuard, roleGuard]
  },
  {
    path: 'profile',
    loadComponent: () =>
      import('./core/components/profile/profile.component').then(
        m => m.ProfileComponent
      ),
    canActivate: [AuthGuard, roleGuard]
  },
  {
    path: 'profile-type',
    loadComponent: () =>
      import('./core/components/profile-type/profile-type.component').then(
        m => m.ProfileTypeComponent
      ),
    canActivate: [AuthGuard, profileGuard]
  },
  {
    path: 'login',
    component: AuthRedirectComponent,
    data: { mode: 'login' }
  },
  {
    path: 'signup',
    component: AuthRedirectComponent,
    data: { mode: 'signup' }
  },
  {
    path: '**',
    component: ErrorComponent,
    title: $localize`Error 404`,
    data: { code: 404 }
  }
];
